export default __webpack_public_path__ + "static/media/11C.29e6bbd4.webp";